export default __webpack_public_path__ + "papadias.2571d1df.svg";